import { Sidebar } from '../sidebar/sidebar.component'
import { Map } from '../map/map.component'
import { AppStyled } from './app.styled'

export const App = () => {
  return (
    <AppStyled>
      <Sidebar></Sidebar>
      <Map></Map>
    </AppStyled>
  )
}
